import React, { HTMLProps } from 'react';

export interface ErrorIconProps extends HTMLProps<HTMLDivElement> {
    backgroundColor?: string;
    exclamationPointColor?: string;
    dataTestId?: string;
}

const ErrorIcon = (props: ErrorIconProps) => {
    const {
        backgroundColor = '#BF152C',
        exclamationPointColor = 'white',
        dataTestId = '',
    } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={dataTestId}
        >
            <path
                d="M16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8Z"
                fill={backgroundColor}
            />
            <path
                d="M7.18623 9.57333L6.91956 3H9.05289L8.78623 9.57333H7.18623ZM6.79956 11.76C6.79956 11.12 7.33289 10.5867 7.98623 10.5867C8.62623 10.5867 9.15956 11.12 9.15956 11.76C9.15956 12.4133 8.62623 12.9467 7.98623 12.9467C7.33289 12.9467 6.79956 12.4133 6.79956 11.76Z"
                fill={exclamationPointColor}
            />
        </svg>
    );
};

export default ErrorIcon;
